import React from "react";
import {
  Box,
  Container,
  Flex,
  VStack,
  HStack,
  Heading,
  Text,
  Image,
} from "@chakra-ui/react";

import social1 from "../../assets/images/opensea 1.svg";
import social2 from "../../assets/images/Vector (4).svg";
import social3 from "../../assets/images/Vector (5).svg";
import social4 from "../../assets/images/Vector (6).svg";
import social5 from "../../assets/images/Vector (7).svg";

function index() {
  return (
    <Container maxW="container.xl" mb={32} w="100%" id="socials">
      <Box w="100%">
        <VStack
          w="100%"
          spacing={{ base: 10, md: 16 }}
          alignItems="center"
          textAlign="center"
        >
          <Heading as="h2" size="xl" textShadow="0px 0px 50px #FFFFFF">
            SOCIALS
          </Heading>

          <Text px={{ base: 3, md: 0 }}>
            IT’S TIME TO LEVEL THE PLAYING FIELD.
          </Text>
          <HStack spacing={{ base: 3, md: 5 }}>
            <a href="https://t.me/+-U5XB4TeqNVjYjgy">
              <Image src={social3} w="30px" />
            </a>
            <a href="https://t.me/Dmitry_Forest">
              <Image src={social2} w="30px" />
            </a>
            <a href="https://discord.gg/K346qxBW">
              <Image src={social4} w="30px" />
            </a>
            <a href="https://www.instagram.com/marbleverse_nft/">
              <Image src={social5} w="30px" />
            </a>
            <a href="https://opensea.io/MarbleverseNFT">
              <Image src={social1} w="30px" />
            </a>
          </HStack>
        </VStack>
      </Box>
    </Container>
  );
}

export default index;
